module.exports = __webpack_public_path__ + "static/media/step-3.dc469b17.png";